import { useId } from 'react';
import { cx } from '../internal/tone';
import { FieldShell, describedBy } from './Field';

export interface SelectOption {
  value: string;
  label: string;
  icon?: string;
}

export interface SelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  error?: string;
  hint?: string;
  required?: boolean;
  disabled?: boolean;
  /** Texto da opção vazia. Se ausente, não há opção vazia. */
  placeholder?: string;
}

/**
 * Escolha de uma opção.
 *
 * <select> nativo por decisão: no Android abre a roda de sistema, grande e já
 * conhecida. Uma lista nossa seria mais bonita e muito pior de usar. O ícone da
 * opção vai no texto porque <option> não aceita elementos.
 */
export function Select({
  label,
  value,
  onChange,
  options,
  error,
  hint,
  required = false,
  disabled = false,
  placeholder,
}: SelectProps) {
  const base = useId();
  const id = `${base}-select`;
  const hintId = `${base}-hint`;
  const errorId = `${base}-error`;

  return (
    <FieldShell
      id={id}
      label={label}
      required={required}
      hint={hint}
      hintId={hintId}
      error={error}
      errorId={errorId}
    >
      <select
        id={id}
        className={cx('flos-select', error && 'flos-select--invalid')}
        value={value}
        disabled={disabled}
        required={required}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy(hint, hintId, error, errorId)}
        onChange={(e) => onChange(e.target.value)}
      >
        {placeholder ? <option value="">{placeholder}</option> : null}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.icon ? `${option.icon} ${option.label}` : option.label}
          </option>
        ))}
      </select>
    </FieldShell>
  );
}
